<template>
    <!--
        主要布局
        nav
        main
        tab page
     -->
    <div class="main_questions_div">
        <Navbar @type="change_type"></Navbar>
        <input type="text" placeholder="请输入问题标题" class="publish_title_input" v-model="title">
        <CKEditor @text="get_content"></CKEditor>
        <button class="publish_button" @click="publish">发布</button>
    </div>
</template>
<script type="text/javascript">
    import questionApi from '@/api/questions/question.js'
    import Navbar from './main_question_publish_sub_components/nav_bar.vue'
    import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                content: '',
                type: 'discussion',
            }
        },
        components: {
            Navbar,
            CKEditor,
        },
        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on
            }),
        },
        methods: {
            ...mapActions({
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class',
                change_show_state: 'loginState/change_show_state',
            }),
            get_content: function (content) {
                this.content = content
            },
            change_type: function (arg) {
                this.type = arg
            },
            publish: async function () {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {
                    let res = await questionApi.publish_question({
                        title: this.title,
                        content: this.content,
                        type: this.type,
                    })
                    let data = JSON.parse(res.data.result)
                    this.change_warning_message(data.message);
                    if (data.code === 'success') {
                        this.change_warning_bar_style_class('success');
                        this.$router.push({name: 'question', params: {id: data.question.id}})
                    } else {
                        this.change_warning_bar_style_class('alert');
                    }

                }
            }
        }
    }

</script>
<style type="text/css" scoped>
    .publish_title_input {
        font-size: 20px;
        padding: .375rem .75rem;
        width: 100%;
        line-height: 1.5;
        /*border: 0;*/
        border-bottom: #ccc 1px solid;
        outline: none;
        box-shadow: none;
        resize: none;
        color: #333;
        margin-bottom: 10px;
        background: #f9f9f9;
    }

    .publish_button {
        padding: 6px 20px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        /*margin-right: 5px;*/
        margin-top: 10px;
        float: right;
    }

    .publish_button:hover {
        color: #fff;
        background: #069a75;
    }

    .main_questions_div {
        background: #fff;
        padding: 30px;
        border: 1px solid #eee;
        margin-bottom: 10px;
    }
</style>
